import React, { useEffect, useState, useRef } from "react";
import Sidebar from "./Sidebar";
import "./Admin.css";
import api, { API_ENDPOINTS } from "../config";

const Adminservices = () => {
  const [services, setServices] = useState([]);
  const [formData, setFormData] = useState({ servicename: "", Description: "" });
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notification, setNotification] = useState({ type: "", message: "" });

  const [images1, setImages1] = useState([]);
  const [images2, setImages2] = useState([]);
  const [images3, setImages3] = useState([]);

  const [existing1, setExisting1] = useState([]);
  const [existing2, setExisting2] = useState([]);
  const [existing3, setExisting3] = useState([]);

  const fileInputRef1 = useRef(null);
  const fileInputRef2 = useRef(null);
  const fileInputRef3 = useRef(null);

  const BackEnd_API_URL = process.env.REACT_APP_API_URL;

  const showNotification = (type, message) => {
    setNotification({ type, message });
    setTimeout(() => setNotification({ type: "", message: "" }), 4000);
  };

  const fetchServices = async () => {
    try {
      const res = await api.get(API_ENDPOINTS.GET_ALL_SERVICES, { withCredentials: true });
      setServices(res.data.services || []);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching services:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const clearFileInputs = () => {
    [fileInputRef1, fileInputRef2, fileInputRef3].forEach(ref => {
      if (ref.current) ref.current.value = "";
    });
  };

  const resetForm = () => {
    setFormData({ servicename: "", Description: "" });
    setImages1([]); setImages2([]); setImages3([]);
    setExisting1([]); setExisting2([]); setExisting3([]);
    setEditingId(null);
    clearFileInputs();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = new FormData();
      data.append("servicename", formData.servicename.trim());
      data.append("Description", formData.Description.trim());
      images1.forEach(img => data.append("carouselRow1", img));
      images2.forEach(img => data.append("carouselRow2", img));
      images3.forEach(img => data.append("carouselRow3", img));

      if (editingId) {
        await api.put(`${API_ENDPOINTS.GET_ALL_SERVICES}/${editingId}`, data, {
          headers: { "Content-Type": "multipart/form-data" },
          withCredentials: true,
        });
        showNotification("success", "Service updated successfully ✅");
      } else {
        await api.post(API_ENDPOINTS.GET_ALL_SERVICES, data, {
          headers: { "Content-Type": "multipart/form-data" },
          withCredentials: true,
        });
        showNotification("success", "Service added successfully ✅");
      }

      resetForm();
      fetchServices();
    } catch (error) {
      console.error("Error saving service:", error);
      showNotification("error", "Failed to save service");
    }
  };

  const handleEdit = (service) => {
    setFormData({
      servicename: service.servicename || "",
      Description: service.Description || "",
    });
    setEditingId(service._id);
    setExisting1(service.carouselRow1 || []);
    setExisting2(service.carouselRow2 || []);
    setExisting3(service.carouselRow3 || []);
    setImages1([]); setImages2([]); setImages3([]);
    clearFileInputs();
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this service?")) {
      try {
        await api.delete(`${API_ENDPOINTS.GET_ALL_SERVICES}/${id}`);
        fetchServices();
        showNotification("success", "Service deleted successfully ✅");
      } catch (error) {
        console.error("Error deleting service:", error);
        showNotification("error", "Failed to delete service ❌");
      }
    }
  };

 const handleClearPhotos = async (id) => {
  if (window.confirm("Remove all photos for this service?")) {
    try {
      const data = new FormData();
      data.append("clearRow1", "true");
      data.append("clearRow2", "true");
      data.append("clearRow3", "true");

      await api.put(`${API_ENDPOINTS.GET_ALL_SERVICES}/${id}`, data, {
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true,
      });

      fetchServices();
      showNotification("success", "All photos cleared ✅");
    } catch (error) {
      console.error("Error clearing photos:", error);
      showNotification("error", "Failed to clear photos ");
    }
  }
};


  const handleImageClick = (img) => {
    window.open(`${BackEnd_API_URL}/uploads/${img}`, "_blank");
  };

  if (loading) return <p>Loading services...</p>;

  return (
    <div className="admin-container">
      <Sidebar />
      <div className="container mt-5">
        {notification.message && (
          <div className={`ik-notification ${notification.type}`}>
            <span>{notification.message}</span>
            <button className="ik-close-btn" onClick={() => setNotification({ type: "", message: "" })}>
              ✖
            </button>
          </div>
        )}

        <h2 className="mb-4">{editingId ? "Edit Service" : "Manage Services"}</h2>

        <form onSubmit={handleSubmit} className="mb-4">
          <div className="mb-3">
            <label className="form-label">Service Name</label>
            <input
              type="text"
              name="servicename"
              value={formData.servicename}
              onChange={handleChange}
              className="form-control"
              placeholder="Enter service name"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Description</label>
            <textarea
              name="Description"
              value={formData.Description}
              onChange={handleChange}
              className="form-control"
              placeholder="Enter description"
              required
            />
          </div>

          {/* File inputs */}
          <div className="mb-3">
            <label className="form-label">Carousel Row 1 Images</label>
            <input type="file" multiple onChange={(e) => setImages1(Array.from(e.target.files))} className="form-control" ref={fileInputRef1} />
          </div>
          <div className="mb-3">
            <label className="form-label">Carousel Row 2 Images</label>
            <input type="file" multiple onChange={(e) => setImages2(Array.from(e.target.files))} className="form-control" ref={fileInputRef2} />
          </div>
          <div className="mb-3">
            <label className="form-label">Carousel Row 3 Images</label>
            <input type="file" multiple onChange={(e) => setImages3(Array.from(e.target.files))} className="form-control" ref={fileInputRef3} />
          </div>

          {[{ label: "Row 1", list: existing1 },
            { label: "Row 2", list: existing2 },
            { label: "Row 3", list: existing3 }]
            .map((row, idx) =>
              row.list.length > 0 && (
                <div className="mb-3" key={idx}>
                  <label className="form-label">Existing {row.label} Images</label>
                  <div className="service-images">
                    {row.list.map((img, i) => (
                      <img
                        key={i}
                        src={`${BackEnd_API_URL}/uploads/${img}`}
                        alt=""
                        style={{
                          width: "60px",
                          height: "60px",
                          objectFit: "cover",
                          marginRight: "5px",
                          cursor: "pointer",
                        }}
                        onClick={() => handleImageClick(img)}
                      />
                    ))}
                  </div>
                </div>
              )
            )}

          <button type="submit" className="btn btn-primary">
            {editingId ? "Update Service" : "Add Service"}
          </button>
          {editingId && (
            <button type="button" className="btn btn-secondary ms-2" onClick={resetForm}>
              Cancel
            </button>
          )}
        </form>

        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Service Name</th>
              <th>Description</th>
              <th>Carousel Rows</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {services.length > 0 ? (
              services.map((service) => (
                <tr key={service._id}>
                  <td>{service.servicename}</td>
                  <td>{service.Description}</td>
                  <td>
                    <div className="service-images">
                      {[...(service.carouselRow1 || []), ...(service.carouselRow2 || []), ...(service.carouselRow3 || [])].map((img, i) => (
                        <img
                          key={i}
                          src={`${BackEnd_API_URL}/uploads/${img}`}
                          alt=""
                          style={{
                            width: "60px",
                            height: "60px",
                            objectFit: "cover",
                            marginRight: "5px",
                            cursor: "pointer",
                          }}
                          onClick={() => handleImageClick(img)}
                        />
                      ))}
                    </div>
                  </td>
                  <td>
                    <button className="btn btn-warning btn-sm me-2" onClick={() => handleEdit(service)}>
                      Edit
                    </button>
                    <button className="btn btn-danger btn-sm me-2" onClick={() => handleDelete(service._id)}>
                      Delete
                    </button>
                    <button className="btn btn-outline-secondary btn-sm" onClick={() => handleClearPhotos(service._id)}>
                      Clear Photos
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center">
                  No services found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Adminservices;
